import { validations } from '@unite-us/client-utils';
import { compact, uniq } from 'lodash';
var maxCostAmountSupportedInCents = 100000000;
var validateCostAmount = function validateCostAmount(value) {
  var enforceRequiredFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var validation = uniq(compact([validations.isGreaterThan(value, null, 0), validations.isLessThan(value, 'Should be less than $1,000,000', maxCostAmountSupportedInCents), enforceRequiredFields ? validations.isRequired(value) : null, Number.isNaN(value) ? 'Required' : null]));
  return validation.length > 0 ? validation : null;
};
export default validateCostAmount;
//# sourceMappingURL=validateCostAmount.js.map